import { createStyles, makeStyles } from '@material-ui/styles';
import themes from 'styles/themes';

export const useStyles = makeStyles(() =>
    createStyles({
        wrapper: {
            margin: 'auto',
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            zIndex: 199,
        },
        main: {
            height: '100%',
        },
        textCheckout: {
            color: themes.palette.primary.main,
            fontWeight: 600,
            fontSize: '14px',
            paddingRight: '11px',
        },
        bagItem: {
            width: '100%',
            display: 'flex',
            padding: '20px 0 ',
            borderBottom: `1px solid ${themes.palette.grey['200']}`,
            fontFamily: 'PoppinsRegular',
            alignItems: 'center',
        },
        itemImg: {
            borderRadius: '4px',
            background: 'transparent',
            objectFit: 'contain',
        },
        itemDetail: {
            flex: 1,
            paddingLeft: '10px',
            display: 'flex',
            flexDirection: 'column',
        },
        itemPrice: {
            flex: 1,
            color: themes.palette.primary.main,
            fontSize: 15,
            fontWeight: 600,
            lineHeight: '20px',
        },
        groupQuantity: {
            padding: '6px',
            border: `1px solid ${themes.palette.secondary['200']}`,
            borderRadius: '29px',
            display: 'flex',
        },
        group: {
            border: 'none',
            padding: '0  20px',
            borderRadius: '29px',
            display: 'flex',
            height: 32,
            background: themes.palette.primary.light,
            fontSize: 12,
            fontWeight: 600,
            fontFamily: 'PoppinsRegular',
            color: 'white',
            margin: 0,
            alignItems: 'center',
            justifyContent: 'center',
            width: 'auto',
        },
        itemQuantity: {
            color: themes.palette.primary.main,
            fontSize: 14,
            fontWeight: 400,
            lineHeight: '20px',
            padding: '0 12px',
        },
        itemName: {
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: 14,
            fontWeight: 600,
            // lineHeight: "20px",
            height: 'auto',
        },
        itemStock: {
            height: '1rem',
        },
        itemDes: {
            color: themes.palette.primary.main,
            fontSize: 14,
            fontWeight: 400,
            opacity: 0.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'column',
            paddingTop: 4,
        },
        totalPrice: {
            fontWeight: 600,
            color: themes.palette.primary.main,
            fontSize: '14px',
            display: 'flex',
            justifyContent: 'space-between ',
            paddingTop: '20px',
            paddingBottom: '20px',
        },
        popupTitle: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '18px 10px 0 10px',
        },
        popupTitleText: {
            flex: 1,
            fontSize: 18,
            fontWeight: 500,
            color: themes.palette.primary.main,
            fontFamily: 'PoppinsRegular',
            margin: 0,
            textAlign: 'center',
        },
        popupTitleIcon: {
            color: themes.palette.primary.main,
        },
        popoverContainer: {
            padding: '10px 16px 6px 16px',
        },
        popoverText: {
            fontFamily: 'PoppinsRegular',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontsize: '14px',
            lineHeight: '20px',
            color: themes.palette.primary.main,
        },
        rootSelect: {
            fontSize: 14,
            color: themes.palette.primary.main,
        },
        outlineSelect: {
            padding: '0 10px',
        },
        itemDropdown: {
            height: 33,
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'space-between',
            paddingRight: '5px',
        },
        widgetShopButton: {
            color: themes.palette.primary.light,
            backgroundColor: themes.palette.primary.main,
            border: 'none',
            borderRadius: 999,
            textTransform: 'uppercase',
            fontSize: 8,
            padding: '5px 8px',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
    }),
);
